import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Row, Col, Badge } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
import { toast } from 'react-toastify';
import axios from 'axios';

const EditLiveStream = ({ show, onHide, streamData }) => {
    const [formData, setFormData] = useState({
        object_type: 'temple',
        object_id: '',
        saint_id: '',
        stream_type: 'youtube',
        stream_category: 'live_darshan',
        youtube_video_id: '',
        stream_key: '',
        rtsp_url: '',
        stream_title: '',
        stream_title_mar: '',
        stream_title_hin: '',
        stream_title_guj: '',
        thumbnail_url: '',
        is_featured: false,
        is_active: 1
    });

    const [waypoints, setWaypoints] = useState([]);
    const [saints, setSaints] = useState([]);
    const [loadingWaypoints, setLoadingWaypoints] = useState(true);
    const [loadingSaints, setLoadingSaints] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [charCount, setCharCount] = useState({
        stream_title: 0,
        stream_title_mar: 0,
        stream_title_hin: 0,
        stream_title_guj: 0
    });


    useEffect(() => {
        fetchWaypoints();
        fetchSaints();
    }, []);

    useEffect(() => {
        console.log('StreamData in EditLiveStream:', streamData);
        if (streamData) {
            const newFormData = {
                object_type: streamData.object_type || 'temple',
                object_id: streamData.object_id || '',
                saint_id: streamData.object_type === 'saint' ? streamData.object_id : '',
                stream_type: streamData.stream_type || 'youtube',
                stream_category: streamData.stream_category || 'live_darshan',  // Add this line
                youtube_video_id: streamData.youtube_video_id || '',
                stream_key: streamData.stream_key || '',
                rtsp_url: streamData.rtsp_url || '',
                stream_title: streamData.stream_title || streamData.temple_name || '',
                stream_title_mar: streamData.stream_title_mar || '',
                stream_title_hin: streamData.stream_title_hin || '',
                stream_title_guj: streamData.stream_title_guj || '',
                thumbnail_url: streamData.thumbnail_url || '',
                is_featured: Boolean(streamData.is_featured),
                is_active: streamData.is_active !== undefined ? streamData.is_active : 1
            };
            console.log('Setting form data to:', newFormData);
            setFormData(newFormData);
            setCharCount({
                stream_title: newFormData.stream_title.length,
                stream_title_mar: newFormData.stream_title_mar.length,
                stream_title_hin: newFormData.stream_title_hin.length,
                stream_title_guj: newFormData.stream_title_guj.length
            });
        }
    }, [streamData]);

    const fetchWaypoints = async () => {
        try {
            setLoadingWaypoints(true);
            const response = await axios.get(`${ServerPath}/live-darshan/waypoints/list`);

            if (response.data.success === 1) {
                setWaypoints(response.data.data);
            } else {
                toast.error('Failed to load waypoints');
            }
        } catch (error) {
            console.error('Error fetching waypoints:', error);
            toast.error('Error loading waypoints');
        } finally {
            setLoadingWaypoints(false);
        }
    };

    const fetchSaints = async () => {
        try {
            setLoadingSaints(true);
            const response = await axios.get(`${ServerPath}/live-darshan/saints/list`);

            if (response.data.success === 1) {
                setSaints(response.data.data);
            } else {
                toast.error('Failed to load saints');
            }
        } catch (error) {
            console.error('Error fetching saints:', error);
            toast.error('Error loading saints');
        } finally {
            setLoadingSaints(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (
            ['stream_title', 'stream_title_mar', 'stream_title_hin', 'stream_title_guj'].includes(name)
        ) {
            if (value.length > 50) {
                toast.error('Title cannot exceed 50 characters', {
                    toastId: 'length-error'
                });
                return;
            }

            setCharCount(prev => ({
                ...prev,
                [name]: value.length
            }));
        }


        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsSubmitting(true);

            // Validation
            if (!formData.object_type || !formData.object_id || !formData.stream_type || !formData.stream_title || !formData.stream_title_guj || !formData.stream_title_hin || !formData.stream_title_mar) {
                toast.error('Please fill in all required fields');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'youtube' && !formData.youtube_video_id) {
                toast.error('YouTube video ID is required');
                setIsSubmitting(false);
                return;
            }

            if (formData.stream_type === 'cctv') {
                if (!formData.stream_key || !formData.rtsp_url) {
                    toast.error('Stream key and RTSP URL are required for CCTV streams');
                    setIsSubmitting(false);
                    return;
                }
            }
            if (!formData.thumbnail_url) {
                toast.error('Thumbnail URL is required');
                setIsSubmitting(false);
                return;
            }

            if (!streamData || !streamData.id) {  // ✅ Check for streamData.id
                toast.error('Stream data is missing');
                setIsSubmitting(false);
                return;
            }

            // ✅ Prepare update payload with stream ID
            const updatePayload = {
                id: streamData.id,
                stream_type: formData.stream_type,
                stream_category: formData.stream_category,  // Add this line
                youtube_video_id: formData.youtube_video_id || null,
                stream_key: formData.stream_key || null,
                rtsp_url: formData.rtsp_url || null,
                stream_title: formData.stream_title,
                stream_title_mar: formData.stream_title_mar || null,
                stream_title_hin: formData.stream_title_hin || null,
                stream_title_guj: formData.stream_title_guj || null,
                thumbnail_url: formData.thumbnail_url || null,
                is_active: formData.is_active,
                is_featured: formData.is_featured ? 1 : 0
            };

            console.log('Sending update request:', {
                url: `${ServerPath}/live-darshan/update`,  // ✅ Use /update endpoint
                data: updatePayload
            });

            const response = await axios.post(`${ServerPath}/live-darshan/update`, updatePayload);  // ✅ Changed endpoint

            console.log('Update response:', response);

            if (response.data.success === 1) {
                toast.success('Stream updated successfully');
                setTimeout(() => {
                    onHide();
                    window.location.reload();
                }, 1500);
            } else {
                toast.error(response.data.message || 'Failed to update stream');
            }
        } catch (error) {
            console.error('Error updating stream:', error);
            toast.error(error.response?.data?.message || 'Error updating stream');
        } finally {
            setIsSubmitting(false);
        }
    };

    const getStreamTypeBadgeColor = () => {
        return formData.stream_type === 'youtube' ? 'danger' : 'info';
    };

    const getStreamTypeText = () => {
        return formData.stream_type === 'youtube' ? 'YouTube Live Stream' : 'CCTV Camera Stream';
    };

    const getObjectTypeText = () => {
        return formData.object_type === 'temple' ? 'Temple/Teertha' : 'Saint';
    };

    const getObjectName = () => {
        if (formData.object_type === 'temple') {
            const waypoint = waypoints.find(w => w.wpt_id === formData.object_id);
            return waypoint?.wpt_name || streamData?.temple_name || '';
        } else {
            const saint = saints.find(s => s.saint_id === formData.object_id || s.saint_id === formData.saint_id);
            return saint?.saint_name || streamData?.temple_name || '';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    console.log('EditLiveStream render with formData:', formData);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            style={{ borderRadius: '10px' }}
        >
            <div style={{ borderRadius: '10px' }}>
                <Modal.Header closeButton style={{ borderBottom: '1px solid #E2E8F0', padding: '20px 24px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Modal.Title style={{ fontWeight: '600', fontSize: '22px' }}>
                                Edit Live Stream
                            </Modal.Title>
                            <Badge bg={getStreamTypeBadgeColor()}>
                                {getStreamTypeText()}
                            </Badge>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '40px' }}>
                            <span style={{ color: '#666', fontSize: '14px', fontWeight: '500' }}>Last Update On:</span>
                            <span style={{ color: '#999', fontSize: '14px' }}>
                                {formatDate(streamData?.updated_at)}
                            </span>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: '24px' }}>
                    <Form>
                        <Row className='mb-3'>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={getStreamTypeText()}
                                        disabled
                                        className="bg-light"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            borderRadius: '6px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream For
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={getObjectTypeText()}
                                        disabled
                                        className="bg-light"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            borderRadius: '6px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        {formData.object_type === 'temple' ? 'Temple / Teertha' : 'Saint'}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={getObjectName()}
                                        disabled
                                        className="bg-light"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            borderRadius: '6px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2">
                                        Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px'
                                        }}
                                        value={formData.is_active}
                                        onChange={(e) => setFormData({ ...formData, is_active: parseInt(e.target.value) })}
                                        required
                                    >
                                        <option value={1}>Active</option>
                                        <option value={0}>Archived</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (English) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title"
                                        value={formData.stream_title}
                                        onChange={handleInputChange}
                                        required
                                        placeholder="English"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Marathi) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_mar"
                                        value={formData.stream_title_mar}
                                        onChange={handleInputChange}
                                        placeholder="मराठी"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Hindi) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_hin"
                                        value={formData.stream_title_hin}
                                        onChange={handleInputChange}
                                        placeholder="हिन्दी"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                        Stream Title (Gujarati) <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="stream_title_guj"
                                        value={formData.stream_title_guj}
                                        onChange={handleInputChange}
                                        placeholder="ગુજરાતી"
                                        style={{
                                            height: '46px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            borderRadius: '6px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    />
                                    <div
                                        className="position-absolute"
                                        style={{
                                            bottom: '15px',
                                            right: '20px',
                                            fontSize: '12px',
                                            color: '#6B7280'
                                        }}
                                    >
                                        {charCount.stream_title}/50
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>

                        {formData.stream_type === 'youtube' && (
                            <Row className='mb-3'>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            YouTube Video ID <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="youtube_video_id"
                                            value={formData.youtube_video_id}
                                            onChange={handleInputChange}
                                            required
                                            placeholder="e.g., dQw4w9WgXcQ"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                        <Form.Text className="text-muted">
                                            (e.g., youtube.com/watch?v=<strong>dQw4w9WgXcQ</strong>)
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                            Thumbnail URL <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="thumbnail_url"
                                            value={formData.thumbnail_url}
                                            onChange={handleInputChange}
                                            placeholder="https://example.com/thumbnail.jpg"
                                            style={{
                                                height: '46px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '6px'
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}

                        {formData.stream_type === 'cctv' && (
                            <>
                                <Row className='mb-3'>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Stream Key <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="stream_key"
                                                value={formData.stream_key}
                                                onChange={handleInputChange}
                                                required
                                                disabled
                                                className="bg-light"
                                                placeholder="e.g., temple-main-camera"
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    borderRadius: '6px',
                                                    cursor: 'not-allowed'
                                                }}
                                            />
                                            <Form.Text className="text-muted">
                                                Stream key cannot be changed (used for FFmpeg process identification)
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                RTSP URL <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="rtsp_url"
                                                value={formData.rtsp_url}
                                                onChange={handleInputChange}
                                                required
                                                placeholder="rtsp://username:password@192.168.1.100:554/stream"
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                            <Form.Text className="text-muted">
                                                (eg: rtsp://user:pass@ip:port/path)
                                            </Form.Text>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                Thumbnail URL <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="thumbnail_url"
                                                value={formData.thumbnail_url}
                                                onChange={handleInputChange}
                                                placeholder="https://example.com/thumbnail.jpg"
                                                style={{
                                                    height: '46px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '6px'
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="checkbox"
                                                label="Featured Stream"
                                                name="is_featured"
                                                checked={formData.is_featured}
                                                onChange={handleInputChange}
                                                style={{ fontSize: '16px', marginTop: '30px' }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className='mb-3'>
                                    {streamData?.hls_url && (
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                    Current HLS URL
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={streamData.hls_url}
                                                    disabled
                                                    className="bg-light"
                                                    style={{
                                                        height: '46px',
                                                        border: '1px solid #E2E8F0',
                                                        borderRadius: '6px',
                                                        fontSize: '12px'
                                                    }}
                                                />
                                                <Form.Text className="text-muted">
                                                    Auto-generated HLS URL (read-only)
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    )}

                                    {streamData?.stream_status && (
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                                                    Stream Status
                                                </Form.Label>
                                                <div>
                                                    <Badge
                                                        bg={
                                                            streamData.stream_status === 'active' ? 'success' :
                                                                streamData.stream_status === 'error' ? 'danger' :
                                                                    'secondary'
                                                        }
                                                        style={{ fontSize: '14px', padding: '8px 12px' }}
                                                    >
                                                        {streamData.stream_status.toUpperCase()}
                                                    </Badge>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    )}
                                </Row>
                            </>
                        )}

                        {formData.stream_type === 'youtube' && (
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            label="Featured Stream"
                                            name="is_featured"
                                            checked={formData.is_featured}
                                            onChange={handleInputChange}
                                            style={{ fontSize: '16px' }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                        <Row className='mb-3'>
    <Col md={3}>
        <Form.Group className="mb-3">
            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500', fontSize: '16px' }}>
                Stream Category <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
                name="stream_category"
                value={formData.stream_category}
                onChange={handleInputChange}
                style={{
                    height: '46px',
                    border: '1px solid #E2E8F0',
                    backgroundColor: '#FFFFFF',
                    borderRadius: '6px'
                }}
            >
                <option value="live_darshan">Live Darshan</option>
                <option value="live_stream">Live Stream</option>
                <option value="live_aarti">Live Aarti</option>
            </Form.Select>
        </Form.Group>
    </Col>
</Row>
                    </Form>
                </Modal.Body>

                <div style={{ padding: '0 24px 24px 0', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant="secondary"
                        onClick={onHide}
                        className="me-2"
                        style={{
                            borderRadius: '6px',
                            padding: '10px 24px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                        style={{
                            backgroundColor: '#5662F6',
                            borderColor: '#5662F6',
                            borderRadius: '6px',
                            padding: '10px 40px',
                            fontWeight: '500',
                            fontSize: '16px'
                        }}
                    >
                        {isSubmitting ? 'Updating...' : 'Update Stream'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default EditLiveStream;